import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

export const Id = pipe(
	string,
	parse((s) => (s.startsWith(`ui-settings:`) ? success(s) : failure(s, 'Invalid ui settings id')))
);
